import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetPlayheadSyncStatusQueryVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
  sequenceId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetPlayheadSyncStatusQuery = { __typename?: 'Query', getPlayheadSyncStatus: { __typename?: 'PlayheadSyncStatus', status: Types.PlayheadSyncStatusState, assetId: string, sequenceId: string } };


export const GetPlayheadSyncStatus = /*#__PURE__*/ gql`
    query GetPlayheadSyncStatus($assetId: ID!, $sequenceId: ID) {
  getPlayheadSyncStatus(assetId: $assetId, sequenceId: $sequenceId) {
    status
    assetId
    sequenceId
  }
}
    ` as unknown as DocumentNode<GetPlayheadSyncStatusQuery, GetPlayheadSyncStatusQueryVariables>;

          

          export const useGetPlayheadSyncStatusQuery = (options?:QueryHookOptions<GetPlayheadSyncStatusQuery, GetPlayheadSyncStatusQueryVariables>) => useQuery(GetPlayheadSyncStatus, options);

          

          export type GetPlayheadSyncStatusQueryOptions = QueryHookOptions<GetPlayheadSyncStatusQuery, GetPlayheadSyncStatusQueryVariables>;

          

          export const useGetPlayheadSyncStatusLazyQuery = (options?:LazyQueryHookOptions<GetPlayheadSyncStatusQuery, GetPlayheadSyncStatusQueryVariables>) => useLazyQuery(GetPlayheadSyncStatus, options);

          

          export type GetPlayheadSyncStatusQueryResult = ReturnType<typeof useGetPlayheadSyncStatusQuery>;

          
